import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_SubstanceUseAdult = ({ itemsRef, showErrorFor }) => {

   return (
      <form id='NBT_SubstanceUseAdult' className='file-pdf-document'>
         <div className='file-template'>

            <h3>
               LEVEL 2-Substance Use-Adult*
            </h3>
            <h3>
               *Adapted from the NIDA-Modified ASSIST
            </h3>
            <table>
               <tr>
                  <td className="w-375">
                     <span className="eleHeader">Name:</span>
                     <input type="text" id="txtChild2" name="txtChild2" className="add-only" />
                  </td>
                  <td className="w-375">
                     <span className="eleHeader">Age:</span>
                     <input type="text" id="txtAge" name="txtAge" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <span className="eleHeader">Sex:</span>
                     <input type="radio" id="rbPregnancy_Yes" name="rbPregnancy" className="add-only" value="1" />&nbsp; Male
                     &nbsp;
                     <input type="radio" id="rbPregnancy_No" name="rbPregnancy" className="add-only" value="0" />&nbsp; Female
                  </td>
                  <td className="w-375">
                     <span className="eleHeader">Date:</span>
                     <input type="date" id="txtDate" name="txtDate" className="add-only" />
                  </td>
               </tr>
            </table>
            <p>
               If the measure is being completed by an informant, what is your relationship with the individual receiving care?
               <input type="text" id="txtChild3" name="txtChild3" className="add-only" />
            </p>
            <p>
               In a typical week, approximately how much time do you spend with the individual receiving care?
               <input type="text" id="txtChild1" name="txtChild1" className="add-only" /> hours/week
            </p>
            <p>
               <strong>Instructions:</strong> On the DSM-5 Level 1 cross-cutting questionnaire that you just completed, you indicated that during
               the past 2 weeks you (the individual receiving care) have been bothered by "using medicines on your own without
               a doctor's prescription, or in greater amounts or longer than prescribed, and/or using drugs like marijuana,
               cocaine or crack, and/or other drugs" at a slight or greater level of severity. The questions below ask how often
               you (the individual receiving care) have used these medicines and/or substances during the past 2 weeks. Please
               respond to each item by marking (&#10003; or x)one box per row.
            </p>
            <table>
               <tr>
                  <td className="w-600">
                     <span className="eleHeader">During the past TWO (2) WEEKS, about how often did you use any of the following
                        medicines ON YOUR OWN, that is, without a doctor's prescription, in greater amounts
                        or longer than prescribed?</span>
                  </td>
                  <td className="w-150 text-center">
                     <span className="eleHeader">Clinician Use</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     &nbsp;
                  </td>
                  <td className="w-200">
                     &nbsp;
                  </td>
                  <td className="w-80 text-center">
                     <strong>Not at all</strong>
                  </td>
                  <td className="w-80 text-center">
                     <strong>One or two days</strong>
                  </td>
                  <td className="w-80 text-center">
                     <strong>Several days</strong>
                  </td>
                  <td className="w-80 text-center">
                     <strong>More than half the days</strong>
                  </td>
                  <td className="w-80 text-center">
                     <strong>Nearly every day</strong>
                  </td>
                  <td className="w-150 text-center">
                     <strong>Item Score</strong>
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     &nbsp;
                  </td>
                  <td className="w-200">
                     &nbsp;
                  </td>
                  <td className="w-80 text-center">
                     0
                  </td>
                  <td className="w-80 text-center">
                     1
                  </td>
                  <td className="w-80 text-center">
                     2
                  </td>
                  <td className="w-80 text-center">
                     3
                  </td>
                  <td className="w-80 text-center">
                     4
                  </td>
                  <td className="w-150 text-center">
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     a.
                  </td>
                  <td className="w-200">
                     Painkillers (like Vicodin)
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight_Yes" name="rbSlight" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight_No" name="rbSlight" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight_Np" name="rbSlight" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight_Nc" name="rbSlight" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight_Nd" name="rbSlight" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain" name="txtDomain" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     b.
                  </td>
                  <td className="w-200">
                     Stimulants (like Ritalin, Adderall)
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight1_Yes" name="rbSlight1" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight1_No" name="rbSlight1" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight1_Np" name="rbSlight1" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight1_Nc" name="rbSlight1" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight1_Nd" name="rbSlight1" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain1" name="txtDomain1" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     c.
                  </td>
                  <td className="w-200">
                     Sedatives or tranquilizers (like sleeping pills or Valium)
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight2_Yes" name="rbSlight2" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight2_No" name="rbSlight2" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight2_Np" name="rbSlight2" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight2_Nc" name="rbSlight2" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight2_Nd" name="rbSlight2" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain2" name="txtDomain2" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">Or drugs like:</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     d.
                  </td>
                  <td className="w-200">
                     Marijuana
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight3_Yes" name="rbSlight3" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight3_No" name="rbSlight3" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight3_Np" name="rbSlight3" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight3_Nc" name="rbSlight3" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight3_Nd" name="rbSlight3" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain3" name="txtDomain3" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     e.
                  </td>
                  <td className="w-200">
                     Cocaine or crack
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight4_Yes" name="rbSlight4" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight4_No" name="rbSlight4" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight4_Np" name="rbSlight4" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight4_Nc" name="rbSlight4" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight4_Nd" name="rbSlight4" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain4" name="txtDomain4" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     f.
                  </td>
                  <td className="w-200">
                     Club drugs (like ecstasy)
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight5_Yes" name="rbSlight5" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight5_No" name="rbSlight5" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight5_Np" name="rbSlight5" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight5_Nc" name="rbSlight5" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight5_Nd" name="rbSlight5" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain5" name="txtDomain5" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     g.
                  </td>
                  <td className="w-200">
                     Hallucinogens (like LSD)
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight6_Yes" name="rbSlight6" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight6_No" name="rbSlight6" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight6_Np" name="rbSlight6" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight6_Nc" name="rbSlight6" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight6_Nd" name="rbSlight6" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain6" name="txtDomain6" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     h.
                  </td>
                  <td className="w-200">
                     Heroin
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight7_Yes" name="rbSlight7" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight7_No" name="rbSlight7" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight7_Np" name="rbSlight7" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight7_Nc" name="rbSlight7" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight7_Nd" name="rbSlight7" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain7" name="txtDomain7" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     i.
                  </td>
                  <td className="w-200">
                     Inhalants or solvents (like glue)
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight8_Yes" name="rbSlight8" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight8_No" name="rbSlight8" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight8_Np" name="rbSlight8" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight8_Nc" name="rbSlight8" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight8_Nd" name="rbSlight8" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain8" name="txtDomain8" className="add-only" />
                  </td>
               </tr>
               <tr>
                  <td className="w-20">
                     j.
                  </td>
                  <td className="w-200">
                     Methamphetamine (like speed)
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight9_Yes" name="rbSlight9" className="add-only" value="1" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight9_No" name="rbSlight9" className="add-only" value="2" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight9_Np" name="rbSlight9" className="add-only" value="3" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight9_Nc" name="rbSlight9" className="add-only" value="4" />
                  </td>
                  <td className="w-80 text-center">
                     <input type="radio" id="rbSlight9_Nd" name="rbSlight9" className="add-only" value="5" />
                  </td>
                  <td className="w-150 text-center">
                     <input type="text" id="txtDomain9" name="txtDomain9" className="add-only" />
                  </td>
               </tr>
            </table>
            <tr>
               <td className="w-600 text-right">
                  <b>Total Score:</b>
               </td>
               <td className="w-150  text-center">
                  <input type="text" id="txtDomain11" name="txtDomain11" className="add-only" />
               </td>
            </tr>
            <p>
               <strong>Instructions to Clinicians</strong>
            </p>
            <p>
               The DSM-5 Level 2-Substance Use-Adult is an adapted version of the NIDA-Modified ASSIST. The 15-item
               measure is used to assess the pure domain of prescription medicine, and illicit substance use in adults age 18 and
               older. It is completed by the individual prior to a visit with the clinician. If the individual receiving care is of
               impaired capacity and unable to complete the form (e.g., an individual with dementia), a knowledgeable
               informant may complete the measure. Each item asks the individual receiving care (or informant) to rate the
               severity of the individual's use of various substances during the past 2 weeks.
            </p>
            <p>
               <strong>Scoring and Interpretation</strong>
            </p>
            <p>
               Each item on the measure is rated on a 5-point scale (i.e., 0=not at all; 1=1 or 2 days; 2=several days; 3=more than
               half the days; 4=nearly every day). The clinician is asked to review the score of each item on the measure during
               the clinical interview and indicate the raw score for each item in the section provided for "Clinician Use." Scores
               on the individual items should be interpreted independently because each item inquires about the use of a
               distinct substance. The rating of multiple items at scores greater than 0 indicates greater severity and complexity
               of substance use.
            </p>
            <p>
               <strong>Frequency of Use</strong>
            </p>
            <p>
               To track change in the severity of the individual's use of alcohol, tobacco/nicotine, prescription or illicit substance
               over time, the measure be may completed at regular intervals as clinically indicated, depending on the stability of the
               individual's symptoms and treatment status. For individuals of impaired capacity, it is preferred that completion of
               the measures at follow-up appointments is by the same knowledgeable informant. Consistently high scores on the
               measure may indicate significant and problematic areas that might warrant further assessment, treatment, and
               follow-up. Your clinical judgment should guide your decision.
            </p>
         </div>
      </form >
   )
}